import { IApiOrderLifetimeRule, IApiOrderLifetimeRuleUpdate, IApiRuleId } from '@cbridge-packages/api';
import { RuleTranslator } from '@cbridge-packages/rule';
import { IOrderLifetimeRule, IOrderLifetimeImportRule } from './orderLifetimeRule.interface';

export namespace OrderLifetimeRuleTranslator {
  export function fromApi(rule: IApiOrderLifetimeRule): IOrderLifetimeRule {
    return RuleTranslator.fromApiBasicRule(rule);
  }

  export function toApi(rule: IOrderLifetimeRule): IApiOrderLifetimeRuleUpdate {
    return RuleTranslator.toApiBasicRule(rule);
  }

  export function fromApiImport(rule: IApiOrderLifetimeRule & IApiRuleId): IOrderLifetimeImportRule {
    const result: IOrderLifetimeImportRule = RuleTranslator.fromApiBasicRule(rule);
    result.id = rule.id;

    return result;
  }
}
